export const SIDEBAR_WIDTH = '80px';
export const SECONDARY_NAV_HEIGHT = '60px';
export const MANAGEMENT_PANEL_HEIGHT = '60px';

export const SCREEN_LG_MIN = '1300px';
